<template>
<div  v-if="modalp" class="modal fade" tabindex="-1" :class="{'mostrar' : modalp}" role="dialog" aria-labelledby="myModalLabel"  aria-hidden="true">
    <div class="modal-dialog modal-primary modal-lg" role="document" >
        <div class="modal-content" :style="'top:'+scroll+'px'">
            <div class="modal-header">
                <h4 class="modal-title" ></h4>
                <button type="button" class="close" @click="cerrarModal()" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="product-details"><!--product-details-->
                    <div class="row detallesPro">
                            <div class="col-sm-5" @click="zoomImagen(producto.imagenes)">
                               
                                <div v-if="producto.imagenes.length>1" class="view-product">
                                    <figure v-for="(img,index) in producto.imagenes" :key="index" >
                                        <img  :class="`img${img.orden} ${[img.orden == 1 ? '' : 'display']}`" width="100%" :src="`${dominio}/img/productos/${img.nombre}`" alt="" />
                                    </figure>
                                </div>
                                <div v-else class="view-product">
                                    <figure v-for="(img,index) in producto.imagenes" :key="index" >
                                        <img width="100%" :src="`${dominio}/img/productos/${img.nombre}`" alt="" />
                                    </figure>
                                </div>
                                <div id="similar-product" class="carousel slide" data-ride="carousel">
                                    
                                   
                                    <a class="left item-control" href="#similar-product" data-slide="prev">
                                        <i class="fa fa-angle-left"></i>
                                    </a>
                                    <a class="right item-control" href="#similar-product" data-slide="next">
                                        <i class="fa fa-angle-right"></i>
                                    </a>
                                </div>

                            </div>
                            <div class="col-sm-7 ">
                                <div class="product-information"><!--/product-information-->
                                <!-- <img src="images/product-details/new.jpg" class="newarrival" alt="" /> -->
                                    <h2>{{producto.nombre}}</h2>
                                    <p v-if="producto.descripcion!='null'">{{producto.descripcion}}</p>
                                    <!-- <img src="images/product-details/rating.png" alt="" /> -->
                                    <span class="left-sidebar flex">
                                        <div v-if="producto.subarticulo">
                                            <ul class="radio">
                                                <li v-for="sub in producto.subarticulo" :key="sub.id">
                                                <label>
                                                    <input class="" type="radio" name="subproducto" @change="listaAtributosOpciones(sub.id)" :value="sub.nombre" v-model="idsub">
                                                    {{sub.nombre}}
                                                </label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div >
                                        <ul class="radio ul-atributos">
                                            <li  v-for="(atr,index) in producto.tipo.atributos" :key="index"  >
                                            <div class="atributos contenedor-seccion" >
                                                <h4 for="">
                                                    <label>
                                                        {{atr.nombre}}
                                                    </label>
                                                    <input type="text" v-model="atr.descripcion" class="form-control" :placeholder="`Escriba detalles de ${atr.nombre}`">
                                                </h4>
                                                <div v-if="atr.tipo_campo==1">
                                                    <select name="" :id="atr.id" v-model="atr.open" @change="obtenerOpcion(atr,atr.tipo_campo,index,$event,atr.open)" class="form-control" :placeholder="`Escriba detalles de ${atr.nombre}`">
                                                        <option value=" " disabled selected>Seleccione tipo de {{atr.nombre}}</option>
                                                        <option v-for="op in atr.opciones" :key="op.id" :value="(op)">
                                                            {{op.label}} {{op.valor}} 
                                                        </option>
                                                    </select>
                                                    
                                                </div> 
                                                <div v-if="atr.tipo_campo==2">
                                                    <label v-for="op in atr.opciones" :key="op.id" >
                                                        <input  class="form-control" type="checkbox" v-model="op.editOpcion" name="atributo" @change="obtenerOpcion(atr.id,atr.tipo_campo,index,$event)" :placeholder="`Escriba el ${atr.nombre}`">
                                                        {{op.label}} {{op.valor}} 
                                                    </label>
                                                    
                                                </div>   
                                               
                                            </div>
                                            
                                            </li>
                                        </ul>  
                                        </div>
                                    </span>
                                    <span>
                                         
                                        <div v-if="producto.tipo.tipo_cantidad.tipo_cantidad=='1'" class="form-group">
                                            <label>Cantidad:</label>
                                             <input type="text" @change="calcularRango" v-model="cantidad"/>
                                        </div>
                                       
                                        <div v-else class="form-group">
                                            <label>Cantidad:</label>
                                            <select name="" id="" v-model="cantidad" @change="calcularRango" >
                                                <option v-for="(valor,index) in producto.tipo.tipo_cantidad.valores" :key="index" :value="valor">{{valor}}</option>
                                            </select>
                                        </div>
                                        <!-- <div class="col-sm-12">
                                            <div class="totales">
                                                <label style="color:green">Este pedido tiene un descuento de</label> <span>$ {{producto.descuento}}</span>
                                            </div>
                                        </div> -->
                                        <div class="col-sm-12">
                                            <div class="totales">
                                                <h4><label>Subtotal:</label> <span>$ {{subtotal}}</span></h4>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="totales">
                                                <h4><label>Descuento:</label> <span>$ {{producto.descuento}}</span></h4>
                                            </div>
                                        </div>
                                        
                                        <div class="col-sm-12">
                                            <div class="totales">
                                                <h4><label>Valor a pagar:</label> <span>$ {{producto.valor_total}}</span></h4>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-success cart" @click="getDatosProducto">
                                            <i class="fa fa-shopping-cart"></i>
                                            Añadir al carrito
                                        </button>
                                    </span>
                                    <div  v-show="errorArticulo" class="form-grou col-md-12 div-error">
                                        <div class="text-center text-error">
                                            <div v-for="error in errorMostrarMsjArticulo" :key="error" v-text="error">

                                            </div>
                                        </div>
                                    </div>
                                   
                                  
                                    <a href=""><img src="images/product-details/share.png" class="share img-responsive"  alt="" /></a>
                                </div><!--/product-information-->
                            </div>
                            
                           
                        </div><!--/product-details-->
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cancelar</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
     <zoomimagen :scroll="scroll" :modalz="modalz" :imagenes="imagenes" @cerrarModalz="cerrarModalz"></zoomimagen>
</div>
<!--Fin del modal-->
</template>
<script>
import { mapState} from 'vuex'
import zoomimagen from './ZoomImagen.vue'
 export default {
    props:{
        modalp:0,
        producto:{},
        scroll:0
    },
    components: {
        zoomimagen
    },
    data(){
        return{
            opcionproduccion:0,
            cantidad:1000,
            valorTotalp:0,
            subtotalp:0,
            descuentop:0,
            customItem:{detalles:[],tamano:0,pliegos:0,descuento:0,cantidad:0,articulo_id:0,valor_unitario:0,atributos:[],subtotal:0,valor_total:0,impuesto:0},
            rangos:[],
            checkboxOp:[],
            porcentajes:0,
            selectOp:0,
            errorArticulo:0,
            errorMostrarMsjArticulo:[],
            modalz:0,
            imagenes:[],
            
        }
    },
    computed:{
        ...mapState(['dominio']),
         descuento(){
          return this.descuento2()
        },
       
        subtotal(){
            return this.subtotal2()
        },
        
        
    },
    methods: {
        
        cerrarModal(){
            this.$emit('cerrarModalp')
        },
       
        cerrarModalz(value){
            this.modalz=value
        },
         zoomImagen(value){
            this.imagenes=value
            this.modalz=1
        },
         subtotal2(){
            var valor=0
            this.producto.tipo.atributos.forEach(a =>{
                valor=parseFloat(a.valor)+valor;
            })
            var totalAtributos =valor*this.cantidad
            var subtotalp=this.producto.tipo.valor*this.cantidad
            this.producto.subtotal=subtotalp+totalAtributos
            var subtotal=this.producto.subtotal
            var descuento=this.producto.subtotal*(this.porcentajes/100)
            var total=this.producto.subtotal-descuento
            this.producto.descuento=descuento
            this.producto.valor_total=total
            this.producto.descuento=descuento
            return subtotal
        },
        descuento2(){
           var des=0
          this.descuentop=des;
          var destofix=((parseFloat(this.porcentajes)/100)*this.subtotalp)
          this.producto.descuento=destofix.toFixed()
          return destofix 
        },
        obtenerOpcion(atr,tipocampo,index,event,open){
           var me =this
            if(tipocampo==2){
                me.producto.tipo.atributos.forEach(e=>{
                    if(e.id==atr.id){
                        e.select=1
                        e.open=[]
                        var valor=0
                        e.opciones.forEach(o=>{
                            if(o.editOpcion=='true' || o.editOpcion==1){
                                e.open.push(o)
                            }else{
                                var opennew=e.open.filter((item) => item.id !== o.id)
                                e.open=opennew
                            }
                        })
                        e.open.forEach(open=>{
                            valor=valor+parseFloat(open.valorOpAtributo)
                        })
                        e.valor=valor
                        
                    }
                    
                })
            }else{
                    atr.valor=parseFloat(open.valor)
            }

        },
        calcularRango(){
            this.producto.tamano=this.producto.tipo.tamano
            this.producto.area=this.producto.tipo.area
            this.producto.cabida=this.producto.tipo.cabida
            this.producto.impresiones=this.producto.tipo.impresiones
            this.producto.valor=this.producto.tipo.valor
            this.producto.sobrante=this.producto.tipo.sobrante
            this.producto.cantidad=this.cantidad
            this.producto.tipo.atributos.forEach(e =>{
                switch(e.tipo_atributo){
                    case '2':
                        this.producto.pliegos=(this.cantidad/this.producto.cabida+this.producto.sobrante)/this.producto.tamano
                        e.total=this.producto.pliegos*e.valor
                    break;
                    case '3':
                        e.total=this.cantidad*this.producto.area*e.valor
                        break;
                   
                }
            })
            this.producto.tipo.rangos.forEach((e)=>{
                if(parseInt(this.cantidad) >= parseInt(e.de) && parseInt(this.cantidad) <= parseInt(e.hasta)){
                    this.porcentajes=e.descuento
                }
            })
        }, 
        totaliva(){
            this.producto.impuesto=this.producto.subtotal*(this.producto.iva/100)
            var resultado=this.producto.impuesto
            return resultado
        },
        abrirOpcionePro(){
            this.opcionproduccion=1
        },
        cerrarOpcionePro(){
            this.opcionproduccion=0
        },
        validarProducto(){
            this.errorArticulo=0;
            this.errorMostrarMsjArticulo =[];
            if (this.cantidad==0) this.errorMostrarMsjArticulo.push("La cantidad no puede estar vacia.");
            this.producto.tipo.atributos.forEach(o =>{
                if(Array.isArray(o.open)){
                    if (o.open.length==0) this.errorMostrarMsjArticulo.push("Seleccione una opción de "+o.nombre);
                }else{
                    if(o.open==false) this.errorMostrarMsjArticulo.push("Seleccione una opción de "+o.nombre);
                } 
            })
        
            if (this.errorMostrarMsjArticulo.length) this.errorArticulo = 1;

            return this.errorArticulo;
        },
        getDatosProducto(){
            if (this.validarProducto()){
                return;
            }
            this.producto.cantidad=this.cantidad
            this.producto.articulo_id=this.producto.id
            var articulo={'nombre':this.producto.nombre}
            this.producto.articulo=articulo
            this.producto.id=0
            this.producto.ordentrabajo_id=0
            this.producto.porcentajes=this.porcentajes
            this.producto.valor_unitario=parseFloat(this.producto.valor_total/this.producto.cantidad)
            this.producto.detalles=[]
            this.producto.tipo.atributos.forEach(e => {
                if(e.tipo_campo==1){
                    if(e.open!=null){
                       
                        var detalle={
                            "titulo":e.nombre,
                            "id":e.open.id,
                            "id_atributo":e.open.id_atributo,
                            "valor":e.open.label,
                            "costo":e.open.valor,
                            "opciones":'',
                            "descripcion":e.descripcion,
                            "alerta":"",
                            "orden":1,
                            "costoop":e.open.costoop
                        }
                        this.producto.detalles.push(detalle)
                    }
                }else{
                    e.open.forEach(o => {
                        var detalle={
                            "nombre":e.nombre,
                            "id":o.id,
                            "id_atributo":o.id_atributo,
                            "label":o.label,
                            "valor":o.valor,
                            "opciones":'',
                            "descripcion":e.descripcion,
                            "alerta":"",
                            "orden":1,
                            "costoop":o.costoop
                        }
                        this.producto.detalles.push(detalle)   
                    });

                }
            });
            this.producto.orden={
                "id":0,
                "articulo_id":this.producto.id,
                "idcostois":null,
                "cantidad":this.cantidad,
                "produccion":this.producto.produccion,
                "ancho_material":this.producto.ancho_material,
                "largo_material":this.producto.largo_material,
                "valor_unitario":this.producto.valor_unitario,
                "unidad_medida":this.producto.unidad_medida,
                "detalles_diseno":this.producto.detalles_diseno,
                "carpeta_cliente":this.producto.carpeta_cliente,
                "observaciones":this.producto.observaciones,
                "totalParcial":this.producto.valor_total,
                "descuento":this.producto.descuento,
                "total":parseFloat(this.producto.valor_total)-parseFloat(this.producto.descuento),
                "prioridad":this.producto.prioridad,
                "plancha":this.producto.plancha,
                "detalles":this.producto.detalles}      
            this.$emit('productoCustom', this.producto)
            this.customItem={detalles:[],tamano:0,pliegos:0,descuento:0,cantidad:0,articulo_id:0,valor_unitario:0,atributos:[],subtotal:0,valor_total:0,impuesto:0}
        },
       
        
        
    },
    mounted() {
       
        //    ,area:producto.tipo.area,sobrante:producto.tipo.sobrante,impresiones:producto.tipo.impresiones,cabida:producto.tipo.cabida,valor:producto.tipo.valor
    },
    created() {
       
        //this.validarCantidad()
    },
}

</script>

<style> 
    .imagenproducto:hover{
        transform: scale(2);
    }
    .product-details{
        margin-bottom: 0;
    }
   
    .atributos{
        margin:5px 0;
        border-bottom: solid 1px #000000;
        padding-bottom: 5px;
    }   
    .atributos h4{
        display: flex;
        justify-content: space-between;
        margin-bottom: 2px;
    }
    .atributos h4 label{
        font-size: 16px;
    }
    .atributos h4 input{
        width:60%;
        font-size: 12px;
    }
    .atributos select{
        font-size: 12px;
    }
    .totales h4{
        display: flex;
        flex-direction: row;
        font-size: 16px;
        margin-top:8px;
    }
    .ul-atributos{
        list-style: none;
    }
    .detallesPro{
        padding:0px 10px;
        background: rgb(245, 245, 245);
    }
    .modal-content{
        width: 100% !important;
        position: absolute !important;
    }
    .modal-body{
        padding:0 !important;
    }
    .mostrar{
        display: list-item !important;
        opacity: 1 !important;
        position: absolute !important;
        background-color: #3c29297a !important;
    }
    .div-error{
        display: flex;
        justify-content: center;
    }
    .text-error{
        color: red !important;
        font-weight: bold;
    }
    .view-product{
        cursor:pointer;
    }
    .display{
        display:none;
    }
    .view-product:hover .img1{
        display:none
    }
    .view-product:hover .img2{
        display:block
    }
    .product-information{
        padding-bottom:0px; 
        padding-left: 0px;
        padding-top: 0px;
    }
    .product-information span{
        display:flex;
        flex-direction: column;
    }
</style>
